export enum SelectedStatus {
    Default = 0,
    Selected = 1
}

export enum Basemaps {
    Mamma = "mammaBasemap",
    Orto = "ortoBasemap",
    Topo10 = "topo10Basemap"
}

export enum Condition {
    Is = "is",
    Not = "not"
}

export enum ApplicantType {
    Individual = 0,
    Company = 1
}

export enum AttachmentType {
    Path = "Download",
    File = "FileProvider"
}

export enum Input {
    Text = "Text",
    TextArea = "TextArea",
    Select = "Select",
    Checkbox = "Checkbox",
    Number = "Number",
    Date = "Date",
    Phone = "Phone",
    Email = "Email",
    Label = "Label"
}

export enum DrawType {
    PointYard = "PointYard",
    PolylineLvmRoad = "PolylineLvmRoad",
    PolylineRoad = "PolylineRoad",
    PolygonProperty = "PolygonProperty"
}

export enum PageId {
    ApplicantForm = "ApplicantForm",
    TermForm = "TermForm",
    DrawingForm = "DrawingForm",
    ConditionsForm = "ConditionsForm",
    SummaryForm = "SummaryForm",
    Submit = "Submit"
}

export enum Result {
    Success = "Success",
    Error = "Error"
}

export enum UploadState {
    UploadGeometries = "UploadGeometries",
    SubmitForm = "SubmitForm",
    CreatePdf = "CreatePdf",
    UploadPdf = "UploadPdf",
    SendEmail = "SendEmail"
}

export enum PrintType {
    Path = 1,
    File = 2
}

export enum OlDrawTypes {
    LineString = "LineString",
    Point = "Point",
    Polygon = "Polygon"
}
